import {
  createRouteCreator,
  routeCreator as programManagementRouteCreator,
} from '@occc-app/routes/ProgramManagement/utils';
import { OfferType } from '@occc-app/offerValidationService/types';
import { LinkItem } from '@occc/ui-design-system';

import { messages } from './messages';

export const routeCreator = createRouteCreator(OfferType.LoyaltyEvent);

export const getLoyaltyEventDetailsPageHeaderLinks = (
  offerName?: string,
  offerId?: string,
): LinkItem[] => [
  {
    to: programManagementRouteCreator.base(),
    label: 'Program Management',
  },
  {
    to: routeCreator.base(),
    label: messages.title,
  },
  {
    key: offerId ? routeCreator.details(offerId) : routeCreator.base(),
    label: offerName,
  },
];

export const getLoyaltyEventUpdatePageHeaderLinks = (
  name: string,
  id: string,
  page: string,
): LinkItem[] => [
  {
    to: programManagementRouteCreator.base(),
    label: 'Program Management',
  },
  {
    to: routeCreator.base(),
    label: messages.title,
  },
  {
    to: routeCreator.details(id),
    label: `${name}`,
  },
  {
    key: routeCreator.update(id),
    label: `${page}`,
  },
];
